Vue.component('editable', {
  delimiters: ['[[', ']]'],
  mixins: [eventHubMixin],
  props: ['editable-id', 'config'],
  data: () => {
    return {}
  },
  methods: {
    openEditor (event) {
      event.preventDefault();
      this.eventHub.$emit('editor:open', {
        editableId: this.editableId,
        config: this.config
      });
    }
  },
  mounted () {
    this.content = this.$refs.content.innerHTML
    this.eventHub.$on(`editable:update:${this.editableId}`, (content) => {
      this.$refs.content.innerHTML = content;
    })
  },
  template: `<span>
    <span ref="content"><slot></slot></span>
    <i class="icon-edit edit" @click.stop="openEditor($event)"></i>
</span>`
})